export default __webpack_public_path__ + "static/media/Amazon-RDS-1.97984188.png";